// extracted by mini-css-extract-plugin
export default {"container":"DateInput_container__vTHpJ","label":"DateInput_label__2U-4V","dateInput":"DateInput_dateInput__c4V5z","active":"DateInput_active__J+sP2"};